import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import positionDropdown from '@utils/dropdownPosition';

const NavbarWithDropdown = ({ brand, dropdownLabel, dropdownItems }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef(null);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isDropdownOpen) return;
    const rafId = requestAnimationFrame(() => {
      if (triggerRef.current && menuRef.current) {
        positionDropdown(triggerRef.current, menuRef.current);
      }
    });
    const handleResize = () => {
      if (triggerRef.current && menuRef.current) {
        positionDropdown(triggerRef.current, menuRef.current);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', handleResize);
    };
  }, [isDropdownOpen]);

  return (
    <nav className="navbar navbar-expand navbar-light bg-light mb-4">
      <span>{brand}</span>
      <ul className="navbar-nav ml-auto">
        <li
          className={`nav-item dropdown ${isDropdownOpen ? 'show' : ''}`}
          ref={containerRef}
        >
          <a
            ref={triggerRef}
            className="nav-link dropdown-toggle"
            href="#!"
            id="navbarDropdown"
            role="button"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown();
            }}
            aria-haspopup="true"
            aria-expanded={isDropdownOpen}
          >
            {dropdownLabel}
          </a>
          <div
            ref={menuRef}
            className={`dropdown-menu dropdown-menu-right animated--grow-in ${
              isDropdownOpen ? 'show' : ''
            }`}
            aria-labelledby="navbarDropdown"
            style={{ fontSize: '13px' }}
          >
            {dropdownItems.map((item, index) => (
              <>
                <a className="dropdown-item" href={item.href} key={index} data-dd-item>
                  {item.label}
                </a>
                {index !== dropdownItems.length - 1 && <div className="dropdown-divider"></div>}
              </>
            ))}
          </div>
        </li>
      </ul>
    </nav>
  );
};

NavbarWithDropdown.propTypes = {
  brand: PropTypes.string.isRequired,
  dropdownLabel: PropTypes.string.isRequired,
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
};

export default NavbarWithDropdown;
